import styled from '@emotion/styled/macro';
import { MEDIA_QUERIES, MAX_DESKTOP_WIDTH } from '../../../constants';

export const ModalRoute = styled.div`
  display: flex;
  flex-direction: column;
  background-color: transparent;

  padding: 0 !important;
  border-radius: 0 !important;
  border: unset !important;
  inset: 0 !important;

  ${MEDIA_QUERIES[0]} {
    width: 100vw;
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    height: 100vh;
    height: var(--app-height);
    inset: unset !important;
    bottom: 0 !important;
  }

  ${MEDIA_QUERIES[1]} {
    // not mobile styles
    width: ${MAX_DESKTOP_WIDTH};
    position: unset !important;
    box-shadow: 0 0 20px rgb(0 0 0 / 30%);
  }
`;

export const Overlay = styled.div`
  background-color: transparent !important;
  z-index: 3;

  ${MEDIA_QUERIES[1]} {
    display: flex;
    justify-content: center;
    box-shadow: 0 0 20px rgb(0 0 0 / 30%);
  }
`;
